import React from "react";
import styles from "./CustomerRating.module.scss";
import Image from "next/image";
import homeStyles from "../../../styles/Home.module.scss";

function CustomerRating() {
  return (
    <div className={styles["customer-rating-wrapper"]}>
      <div className={styles["customer-rating-content"]}>
        <h2>
          Leverage{" "}
          <span className={homeStyles["span-gradient"]}>Customer Reviews </span>
          & Ratings Dashboard
        </h2>
        <p>
          Socommerz Price Engine offers a &apos;Rating Dashboard&apos; to
          monitor customer reviews. This tool offers a comprehensive summary of
          all reviews across multiple websites, allowing for a granular
          breakdown by category, brand, or competitor. Gain insights into
          competitors’ successes and strategies to enhance your own review
          management.
        </p>
        <ul className={styles["list"]}>
          <li className={styles["list-item"]}>
            <img
              src="features-icon2.webp"
              alt="icon1"
              style={{ width: 15, height: 15, marginTop: 6 }}
            />
            <p className={styles["list-item-text"]}>
              {" "}
              Gain insights into trending keywords across various marketplaces
              and search engines.
            </p>
          </li>
          <li className={styles["list-item"]}>
            <img
              src="features-icon2.webp"
              alt="icon1"
              style={{ width: 15, height: 15, marginTop: 6 }}
            />
            <p className={styles["list-item-text"]}>
              Identify successful patterns among products capturing search share
              and apply these strategies throughout your product lineup.
            </p>
          </li>
          <li className={styles["list-item"]}>
            <img
              src="features-icon2.webp"
              alt="icon1"
              style={{ width: 15, height: 15, marginTop: 6 }}
            />
            <p className={styles["list-item-text"]}>
              Analyze common links between products winning the share of search
              and use trending keywords for better outreach.
            </p>
          </li>
          <li className={styles["list-item"]}>
            <img
              src="features-icon2.webp"
              alt="icon1"
              style={{ width: 15, height: 15, marginTop: 6 }}
            />
            <p className={styles["list-item-text"]}>
              Monitor, manage, and optimize content, ensuring it aligns with
              Brand&apos;s Social Media engagements .
            </p>
          </li>
        </ul>
      </div>
      <div className={styles["customer-rating-image"]}>
        <Image
          src={"/reviewrating/Ratings.jpg"}
          alt=""
          width={500}
          height={400}
          className={styles["rating-image"]}
        ></Image>
      </div>
    </div>
  );
}

export default CustomerRating;
